import styled from 'styled-components'
import Flex from 'components/Flex'
import SelectLocal from 'components/Form/Select'
import { Form as AntdForm } from 'antd'

export const FormItem = styled(AntdForm.Item)`
  margin-top: 0px;
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px'} !important;
  width: 100%;
  .ant-form-item-explain-error {
    padding-left: ${props => (props.padding ? '15%' : '0')};
  }
  .ant-form-item-control-input {
    min-height: 0px;
  }
`

export const ButtonLocal = styled.button`
  width: 100%;
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
`

export const LocalDiv = styled(Flex)`
  width: 50%;
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 10px;
  margin-top: 2px;
  cursor: pointer;
`

export const Text = styled.div`
  font-weight: 600;
  font-size: 1em;
  line-height: 18px;
  color: #3249d7;
`
export const Container = styled(Flex)`
  width: 100%;
  height: auto;
  padding: 25px;
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  margin-bottom: 20px;
`
export const Heading = styled.div`
  font-weight: 600;
  font-size: 1.1428571428571428em;
  line-height: 21px;
  color: ${props => (props.color ? props.color : '#010e30')};
  margin-bottom: 5px;
  font-size: 16px;
`
export const SubHeading = styled.div`
  font-weight: 500;
  font-size: 0.8571428571428571em;
  line-height: 15px;
  color: #999fac;
`

export const SelectLocalWrapper = styled(SelectLocal)`
  position: relative;
  top: -60px;
  opacity: 0;
  width: 50%;
  background: #ffffff;
  border: 1px solid #ebecee;
  box-shadow: 0px 4px 12px rgba(153, 153, 153, 0.1);
  border-radius: 10px;
`

export const HeadingUpload = styled.div`
  margin-top: 10px;
  font-weight: 600;
  font-size: 1em;
  line-height: 18px;
  color: #343e59;
`

export const SubHeadingUpload = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 0.8571428571428571em;
  line-height: 15px;
  color: #999fac;
`

export const GreyText = styled.div`
  font-weight: 700;
  font-size: 0.9285714285714286em;
  line-height: 18px;
  color: #a4a5a7;
`
export const Icon = styled.div`
  margin-right: 5px;
  width: 40px;
  height: 40px;
  background: #ebecee;
  border-radius: 4px;
`
export const HeadingMarksheet = styled.div`
  font-weight: 700;
  font-size: 1em;
  line-height: 20px;
  color: #343e59;
`
export const FileMarksheet = styled.div`
  font-weight: 400;
  font-size: 1em;
  line-height: 20px;
  color: #343e59;
`

export const FileInput = styled.input`
  opacity: 0;
  display: block;
  width: 80px;
  position: relative;
  top: -40px;
`
export const AdjustIcon = styled.div`
  margin-top: 6px;
`

export const OptionWrapper = styled(Flex)`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${props => (props?.isAdded ? '#B3B7C1' : '#343e59')};
  height: 35px;
  padding-left: 15px;
  pointer-events: ${props => (props?.isAdded ? 'none' : 'auto')};
`
export const MarksFlex = styled(Flex)`
  gap: 20px;
  margin-top: 10px;
`
export const IconView = styled.div`
  cursor: 'pointer';
`
export const CurrentWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #cccfd6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  text-align: center;
  margin-right: 10px;
`

export const CurrentText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  align-items: center;
  text-align: center;
  color: #323538;
  display: flex;
  padding: 0px 10px;
`
export const LabelWrapper = styled(Flex)`
  width: 50%;
`

export const InputWrapper = styled(Flex)`
  width: 50%;
`
export const SpinWrapper = styled(Flex)`
  padding-top: 30px;
  padding-bottom: 30px;
`
export const StyledFormItem = styled.div`
  display: ${(props) => (props.show ? 'block' : 'none')};
  width:100%;
`
export const UploadMarksheetButton = styled.button`
  background: #f5f6ff;
  border: 1px solid #d6dbff;
  color: #4f5dff;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  height: 36px;
  padding: 0 16px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content; 
  cursor: pointer;
  &:hover {
    background: #eceeff;
  }
`;